import { render } from "./vehicle-grid.vue?vue&type=template&id=836de204"
import script from "./vehicle-grid.vue?vue&type=script&lang=js"
export * from "./vehicle-grid.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__